// © Microsoft Corporation. All rights reserved.

import {ReactionBreakdownListItemTelemetryObjects, reactionBreakdownListItemTelemetryContracts} from "./ReactionBreakdown.telemetry";
import { TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { addOrUpdateTelemetryObject, renderHybrid } from "../Social.telemetry";

import { ComponentConnector } from "../Social.props";
import FollowButton from "../follow-button/FollowButton";
import React from "react";
import { SocialLocalizedStrings } from "../Social.localizedStrings";
import { User } from "@msnews/social-data-service";
import avatarFallback from "../utils/avatarFallback";
import openProfilePage from "../utils/openProfilePage";
import { placeholderImages } from "../utils/images";
import { renderEmojiByType } from "../utils/emojiIcons";

export interface ReactionBreakdownListItemProps {
    componentConnector: ComponentConnector;
    isAnonymous: boolean,
    user: User,
    rateValue: string,
    managedClasses,
    usersConnector,
    market,
    onFollow?: (e: any, userId: string, isFollow: boolean) => void,
    onLoad?: (target: any, userId: string) => void,
    mainTelemetryObject?: TelemetryObjectBase,
    t: SocialLocalizedStrings,
    theme: string
}

export default class ReactionBreakdownListItem extends React.Component<ReactionBreakdownListItemProps> {
    containerRef: HTMLLIElement;
    isLoaded: boolean;
    telemetryObjects: ReactionBreakdownListItemTelemetryObjects;

    constructor(props) {
        super(props);

        this.containerRef = null;
        this.isLoaded = false;
    }

    followClickHandler(e, userId, isFollow) {
        if (this.props.onFollow) { this.props.onFollow(e, userId, isFollow); }
    }

    render() {
        const {componentConnector, isAnonymous, user, rateValue, managedClasses, usersConnector, market, mainTelemetryObject, t, theme} = this.props;
        /** Generate telemetry objects */
        const containerTelemetryObject = addOrUpdateTelemetryObject(mainTelemetryObject, mainTelemetryObject.contract, { type: TelemetryContentType.Profile }, this.telemetryObjects && this.telemetryObjects.container);
        this.telemetryObjects = {
            container: containerTelemetryObject,
            userName: addOrUpdateTelemetryObject(containerTelemetryObject, reactionBreakdownListItemTelemetryContracts.userNameAndProfilePic, {id: user.traceId || user.id, headline: user.primaryName }, this.telemetryObjects && this.telemetryObjects.userName),
            profilePicture: addOrUpdateTelemetryObject(containerTelemetryObject, reactionBreakdownListItemTelemetryContracts.userNameAndProfilePic, { id: user.traceId || user.id, headline: user.primaryName }, this.telemetryObjects && this.telemetryObjects.profilePicture)
        };

        return (
            <li {...renderHybrid(this.telemetryObjects && this.telemetryObjects.container, true)}>
                <div className="float-item">
                    <a
                        className="cwt-link cwt-avatar-link"
                        {...openProfilePage(componentConnector, theme, user.id, market, "_blank")}
                        {...renderHybrid(this.telemetryObjects && this.telemetryObjects.profilePicture, true, (el) => { this.containerRef = el; })}
                    >
                        <img alt={t.AriaLabelsProfilePicture} className="cwt-avatar cwt-avatar-md" src={user.primaryAvatar || placeholderImages.avatar} onError={(e)=>{ avatarFallback(e); }} />
                    </a>
                    <i className="cwt-reaction cwt-icon">
                        {renderEmojiByType(rateValue)}
                    </i>
                    {isAnonymous ?
                        <div className="cwt-name">{user.primaryName}</div> :
                        <div className="cwt-name cwt-link"  no-access="true" >
                            <a
                                {...renderHybrid(this.telemetryObjects && this.telemetryObjects.userName, true, (el) => { this.containerRef = el; })}
                                {...openProfilePage(componentConnector, theme, user.id, market, "_blank")}>
                                {user.primaryName}
                            </a>
                        </div>
                    }
                </div>

                <div className="float-item">
                    <FollowButton {...{ userId: user.id, managedClasses, usersConnector, t, mainTelemetryObject}} onClick={this.followClickHandler.bind(this)} />
                </div>
            </li>
        );
    }
}